/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import {
  TeamLogo,
  LargeButton,
  LoginWrapper,
  TextboxWarning,
  InputComponent,
} from '../../components';
import {
  LoginLogo,
  ForgotForm,
  LoginRecovery,
  LoginLogoSpan,
  SuccessParagraphs,
  LoginRecoveryEmail,
  LoginRecoveryTitle,
  LoginRecoveryParagraphs,
} from './styles';
import { Utils } from '../../utils/api';
import { useHistory } from 'react-router-dom';
import { Auth as AuthClass } from '../../utils/api';
import { useInputValue } from '../../utils/hooks/useInputValue';

export default () => {
  const utils = new Utils();
  const Auth = new AuthClass();
  const history = useHistory<History>();

  const [loading, useLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const isValidEmail = utils.GetValidationEmailPattern();
  const UserName = useInputValue(history.location.state['email']);

  function HandleFocus(input: any) {
    input.HandleWarning('');
    input.HandleStatus('normal');
  }

  async function HandleRecovery(e) {
    e.preventDefault();
    if (!Boolean(UserName.value.length)) {
      UserName.HandleWarningTitle('Fill the email address information');
      UserName.HandleWarning('You’ll need your email address to reset your password');
      UserName.HandleStatus('error');
    } else if (!Boolean(isValidEmail.test(UserName.value))) {
      UserName.HandleWarningTitle('Incorrect email');
      UserName.HandleWarning('Please enter a valid email');
      UserName.HandleStatus('error');
    } else {
      useLoading(true);
      const response: any = await Auth.RecoverPassword(UserName.value);
      if (response.status) {
        setEmailSent(true)
      } else {
        UserName.HandleWarningTitle('Account does not exist')
        UserName.HandleWarning('Specified account does not exist');
        UserName.HandleStatus('error');
      }
      useLoading(false);
    }
  }

  return (
    <>
      <LoginWrapper isLoading={loading} topLoader={230} isHistory={emailSent ? false : true}>
        <LoginLogo>
          <TeamLogo mWidth="200px" mHeight="40px" />
          <LoginLogoSpan>Measure. Monitor. Optimize</LoginLogoSpan>
        </LoginLogo>
        <LoginRecovery data-cy="login-recovery">
          {!emailSent ? (
            <>
              <LoginRecoveryTitle>Forgot Password?</LoginRecoveryTitle>
              <LoginRecoveryParagraphs>
                <p>Enter the email address you used when you joined and we’ll send you instructions to reset your password.</p>
                For security reasons, we do NOT store your password. So rest assured that we will never send your password via email.
              </LoginRecoveryParagraphs>
              <LoginRecoveryEmail>Email Address</LoginRecoveryEmail>
              <ForgotForm onSubmit={HandleRecovery}>
                <InputComponent
                  fontSize={16}
                  inputStyle="dark"
                  disabled={loading}
                  bordeRadius={'4px'}
                  dynamicSearch={UserName}
                  backgroundColor={'#F4F5F7'}
                  colorPlaceholder={'#D8DDE3'}
                  placeholder={'your@email.com'}
                  insetShadow="rgb(247, 247, 247)"
                  HandleFocus={() => HandleFocus(UserName)}
                />
                <TextboxWarning status={UserName.status} title={UserName.warningTitle} message={UserName.warningMessage} />
              </ForgotForm>
              <LargeButton
                fullWidth
                lMargin="0"
                title="Send"
                fSize={'16px'}
                bradius={'8px'}
                rColor="#017CFF"
                bColor="#FFFFFF"
                disabled={loading}
                xMargin={'5vh 0 0;'}
                callback={HandleRecovery}
                colorDisabled={'#B3D7FF'}
                dataCy="login-recovery-button"
              />
            </>
          ) : (
            <>
              <LoginRecoveryTitle>Email Send!</LoginRecoveryTitle>
              <SuccessParagraphs>The instructions to reset your password has <br />been sent to your email.</SuccessParagraphs>
              <LargeButton
                fullWidth
                lMargin="0"
                fSize={'16px'}
                bradius={'8px'}
                rColor="#017CFF"
                bColor="#FFFFFF"
                xMargin={'5vh 0 0;'}
                title="Go to Sign in"
                callback={() => history.goBack()}
              />
            </>
          )}
        </LoginRecovery>
      </LoginWrapper>
    </>
  );
};
